export type ProductModalLocationState = {
    isProductDetailsModalOpen: boolean;
    productCode: string;
};

export const ESHOP_QUERY_KEY = {
    CART: 'cart',
    BASE_PRODUCT: 'base_product',
    PRODUCT_METADATA: 'product_metadata',
    PRODUCT_VARIANT: 'product_variant',
    PRODUCT_CATEGORY: 'product_category',
    PRODUCT_REFERENCES: 'product_references',
    DELIVERY_MODES: 'delivery_modes',
    ORDER: 'order',
    CONFIRMATION_ORDER: 'confirmation_order',
    ALL_ACCOUNTS: 'all_accounts',
    TELCO_OPERATORS: 'telco_operators',
    TERMS_OF_USE_TEXT: 'terms_of_use_text',
    DISCOUNT_CHECK: 'discount_check',
    CONTENT_SLOT: 'content_slot',
};

export const ESHOP_MUTATION_KEY = {
    ADD_RATE_PLAN: 'add_rate_plan',
    DELETE_RATE_PLAN: 'delete_rate_plan',
    ADD_LEASING_PLAN: 'add_leasing_plan',
    DELETE_LEASING_PLAN: 'delete_leasing_plan',
    ADD_EXTENDED_WARRANTY: 'add_extended_warranty',
    DELETE_EXTENDED_WARRANTY: 'delete_extended_warranty',
    ADD_CART_ENTRY: 'add_cart_entry',
    DELETE_CART_ENTRY: 'delete_cart_entry',
    SUBMIT_COUPON: 'submit_coupon',
    DELETE_COUPON: 'delete_coupon',
    SET_DELIVERY_OPTIONS: 'set_delivery_options',
    UPDATE_RENTING_PLAN: 'update_renting_plan',
    VAT_CONFIG: 'vat_config',
    CLONE_CART: 'clone_cart',
    MIGRATE_CART: 'migrate_cart',
    UPDATE_INITIAL_DEPOSIT: 'update_initial_deposit',
    UPDATE_INITIAL_PAYMENT_OPTION: 'update_initial_payment_option',
    UPDATE_INSURANCE: 'update_insurance',
    UPDATE_CONTRACT_TYPE: 'update_contract_type',
    FORCE_CREATE_CART: 'force_create_fresh_cart',
    UPDATE_NETFLIX: 'update_netflix',
    UPDATE_DISNEY: 'update_disney',
    SAVE_PLAN_ORDER: 'save_plan_order',
};
